export interface JobSeekerProfileData {
  jobTypes: string[];
  locations: string[];
  skills: string[];
  experience: string;
  availability: string;
  desiredPay: string;
  certifications: string[];
  about: string;
  photoUrl?: string;
  photoFile?: File;
  email?: string;
  phone?: string;
  resumeUrl?: string;
  resumeFile?: File;
  audioUrl?: string;
  audioFile?: File;
  voiceIntroUrl?: string;
  videoUrl?: string;
  videoFile?: File;
}

export interface JobSeekerProfile extends JobSeekerProfileData {
  id: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export const JOB_TYPES = [
  'full-time',
  'part-time',
  'seasonal',
  'temporary'
] as const;

export const EXPERIENCE_LEVELS = [
  'entry',
  '1-3',
  '3-5',
  '5+'
] as const;

export const AVAILABILITY_OPTIONS = [
  'immediate',
  '2-weeks',
  '1-month',
  'flexible'
] as const;

export type UserRole = 'shipper' | 'carrier' | 'broker' | 'admin';

export interface UserProfile {
  id: string;
  user_id: string;
  role: UserRole;
  company_name: string | null;
  dot_number: string | null;
  mc_number: string | null;
  phone: string | null;
  avatar_url: string | null;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface LoadDocument {
  id: string;
  job_id: string;
  document_type: 'bol' | 'pod' | 'rate_confirmation';
  status: 'draft' | 'pending_signature' | 'signed' | 'completed';
  created_by: string;
  shipper_signature: string | null;
  carrier_signature: string | null;
  shipper_signed_at: string | null;
  carrier_signed_at: string | null;
  document_data: Record<string, unknown>;
  notes: string | null;
  file_url: string | null;
  created_at: string;
  updated_at: string;
}

export interface Invoice {
  id: string;
  invoice_number: string;
  job_id: string;
  shipper_id: string;
  carrier_id: string;
  status: 'draft' | 'sent' | 'paid' | 'overdue' | 'cancelled';
  subtotal: number;
  tax_amount: number;
  total: number;
  due_date: string;
  paid_at: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
  line_items?: InvoiceLineItem[];
}

export interface InvoiceLineItem {
  id: string;
  invoice_id: string;
  description: string;
  quantity: number;
  unit_price: number;
  total: number;
  created_at: string;
}

export interface Message {
  id: string;
  job_id: string;
  sender_id: string;
  content: string;
  is_read: boolean;
  created_at: string;
}

export interface AppNotification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  type: 'load_update' | 'message' | 'payment' | 'document' | 'rating' | 'system' | 'job_alert';
  reference_id: string | null;
  reference_type: string | null;
  is_read: boolean;
  created_at: string;
}

export interface Rating {
  id: string;
  job_id: string;
  reviewer_id: string;
  reviewee_id: string;
  rating: number;
  review_text: string | null;
  on_time: boolean | null;
  communication: number | null;
  cargo_condition: number | null;
  created_at: string;
}